const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER;

export { MAX_SAFE_INTEGER };
